import {FC, useEffect} from 'react';

import {PropertyRulesItem} from '@stencil/hotels-cg-reducer/src/details/types';
import {pushga} from '@stencil/ga-utils';
import {gaConfig} from '@stencil/hotels-config';
import useDetailsScrollGa from '@stencil/use-details-scroll-ga';

import * as S from './PropertyRules.styles';
// import {propertyRuleData} from './data.ts';

import PropRules from './PropRules/PropRules';

interface PropertyRulesProps {
  heading: string;
  subHeading?: string;
  propertyRules: {
    allowed: PropertyRulesItem[];
    notAllowed: PropertyRulesItem[];
  };
  hasFndAllowedRules: boolean;
  hasFndNotAllowedRules: boolean;
}

const PropertyRules: FC<PropertyRulesProps> = ({
  heading,
  propertyRules,
  hasFndAllowedRules,
  hasFndNotAllowedRules,
  subHeading = 'For Food & Beverages',
}) => {
  const {foodPropertyRulesWatcherRef} = useDetailsScrollGa();

  return (
    <S.PropertyRuleCont ref={foodPropertyRulesWatcherRef}>
      <S.PropertyRuleInner>
        {/* {heading && <h2>{heading}</h2>} */}
        <S.Card>
          {heading && (
            <S.PropertyRuleHeader>
              {heading}
              <S.PropertyRuleSubHeader>{subHeading}</S.PropertyRuleSubHeader>
            </S.PropertyRuleHeader>
          )}
          {/* {subHeading &&  */}
          <S.PropertyRules>
            {hasFndAllowedRules && <PropRules heading="Allowed" data={propertyRules.allowed} />}
            {hasFndNotAllowedRules && (
              <PropRules heading="Not Allowed" data={propertyRules.notAllowed} />
            )}
          </S.PropertyRules>
        </S.Card>
      </S.PropertyRuleInner>
    </S.PropertyRuleCont>
  );
};

export default PropertyRules;
